/* eslint-disable max-len */
import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import "../styles/styles.scss";

const PaymentPage = () => (
  <div className="blurred-background">
    <Helmet>
      <title>Extra English - płatność</title>
    </Helmet>
    <div className="container-fluid" width="100%" height="100%">
      <div className="pt-2 row content">
        <div className="col-xl-2" />
        <div className="col-xl-8">
          <div className="card">
            <div className="card-header">
              <div className="redLine">
                <div className="title">
                  <h2>Szczegóły płatności</h2>
                </div>
                <div className="line" style={{ marginTop: "15px", marginLeft: "2px" }} />
              </div>
            </div>
            <div className="card-body">
              <div style={{ textAlign: "justify" }}>
                <h3>Dane do przelewu</h3>
                <p>Konto bankowe: 36 1140 2004 0000 3502 8025 8272</p>
                <p style={{ color: "red" }}>
                  *UWAGA w tytule przelewu prosimy wpisać imię i nazwisko dziecka, nazwę grupy oraz termin zajęć.
                  Więcej informacji znajduje się w umowie.
                  <a
                    href="../../resources/offer/umowa_o_nauke_angielskiego_2025.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-info ml-3"
                  >
                    Umowa o świadczenie usług
                  </a>
                </p>

                <h3>Metody płatności online</h3>
                <p>
                  Jeżeli dla danej usługi udostępniona jest płatność online, obsługa płatności jest realizowana przez Autopay S.A.
                  Dostępne metody mogą obejmować szybki przelew, BLIK, płatność kartą oraz inne metody udostępnione przez operatora.
                </p>
                <p>
                  Płatności kartą mogą być realizowane kartami: Visa, Visa Electron, Mastercard, Mastercard Electronic oraz Maestro.
                  Extra English nie przechowuje danych kart płatniczych.
                </p>
                <p>
                  Czas realizacji zamówienia jest liczony od momentu uzyskania pozytywnej autoryzacji płatności. Zasady zwrotów i reklamacji
                  opisuje <Link to="/regulamin">Regulamin świadczenia usług Extra English</Link>.
                </p>
              </div>
            </div>
          </div>
          <div className="card-footer" />
        </div>
      </div>
      <div className="col-xl-2" />
    </div>
  </div>
);

export default PaymentPage;
